<template>
    <div>
        <div class="card mb-4">
            <h2 class="text-xl font-bold mb-1">Admin Management</h2>
            <p class="text-gray-500 text-sm">Kelola Role, Menu, dan Role-Menu Assignment</p>
        </div>
        
        <!-- Compact Stats Row -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <Link :href="route('admin.roles')" class="card stat-card hover:shadow-lg transition-shadow cursor-pointer">
                <div class="flex items-center gap-4">
                    <div class="stat-icon bg-blue-100 text-blue-600">
                        <i class="pi pi-users"></i>
                    </div>
                    <div>
                        <p class="text-2xl font-bold">{{ roleCount }}</p>
                        <p class="text-gray-500 text-sm">Roles</p>
                    </div>
                </div>
            </Link>
            
            <Link :href="route('admin.menus')" class="card stat-card hover:shadow-lg transition-shadow cursor-pointer">
                <div class="flex items-center gap-4">
                    <div class="stat-icon bg-green-100 text-green-600">
                        <i class="pi pi-bars"></i>
                    </div>
                    <div>
                        <p class="text-2xl font-bold">{{ menuCount }}</p>
                        <p class="text-gray-500 text-sm">Menus</p>
                    </div>
                </div>
            </Link>
            
            <Link :href="route('admin.rolemenus')" class="card stat-card hover:shadow-lg transition-shadow cursor-pointer">
                <div class="flex items-center gap-4">
                    <div class="stat-icon bg-purple-100 text-purple-600">
                        <i class="pi pi-sitemap"></i>
                    </div>
                    <div>
                        <p class="text-2xl font-bold">→</p>
                        <p class="text-gray-500 text-sm">Role-Menu</p>
                    </div>
                </div>
            </Link>
        </div>
        
        <!-- Quick Actions -->
        <div class="card">
            <h3 class="font-semibold mb-3">Quick Actions</h3>
            <div class="flex flex-wrap gap-2">
                <Link :href="route('admin.roles.create')">
                    <Button label="Tambah Role" icon="pi pi-plus" class="p-button-sm p-button-primary" />
                </Link>
                <Link :href="route('admin.menus')">
                    <Button label="Kelola Menu" icon="pi pi-bars" class="p-button-sm p-button-success" />
                </Link>
                <Link :href="route('admin.rolemenus')">
                    <Button label="Assign Menu" icon="pi pi-link" class="p-button-sm p-button-info" />
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Button from "primevue/button";
import { Link } from '@inertiajs/inertia-vue3';

export default {
    name: "AdminManagementIndex",
    layout: AppLayout,
    components: {
        Button,
        Link,
    },
    props: {
        roleCount: Number,
        menuCount: Number,
    },
}
</script>

<style scoped>
.card {
    background: white;
    padding: 1rem;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-card {
    text-decoration: none;
    color: inherit;
}

.stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
}

.grid {
    display: grid;
}

.grid-cols-1 {
    grid-template-columns: repeat(1, 1fr);
}

@media (min-width: 768px) {
    .md\:grid-cols-3 {
        grid-template-columns: repeat(3, 1fr);
    }
}

.gap-4 {
    gap: 1rem;
}

.gap-2 {
    gap: 0.5rem;
}

.mb-4 {
    margin-bottom: 1rem;
}

.mb-1 {
    margin-bottom: 0.25rem;
}

.mb-3 {
    margin-bottom: 0.75rem;
}
</style>

